(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-footer"]) return;
  try {
    
  (function() {
    var wrapper = document.querySelector('.fw-article__share-wrapper');
    if (!wrapper) return;

    var trigger = wrapper.querySelector('.fw-article__share-trigger');
    var menu = wrapper.querySelector('.fw-article__share-menu');

    function closeMenu() {
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = menu.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
      menu.setAttribute('aria-hidden', !isOpen);
    });

    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) closeMenu();
    });

    menu.addEventListener('click', function(e) {
      var link = e.target.closest('[data-sharer]');
      if (!link) return;
      e.preventDefault();

      var sharer = link.getAttribute('data-sharer');
      var url = encodeURIComponent(link.getAttribute('data-url') || '');
      var title = encodeURIComponent(link.getAttribute('data-title') || '');
      var image = encodeURIComponent(link.getAttribute('data-image') || '');
      var shareUrl = '';
      var w = 600, h = 480;

      switch (sharer) {
        case 'facebook':
          shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
          break;
        case 'twitter':
          shareUrl = 'https://twitter.com/intent/tweet?text=' + title + '&url=' + url;
          break;
        case 'linkedin':
          shareUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + url;
          break;
        case 'whatsapp':
          shareUrl = 'https://api.whatsapp.com/send?text=' + title + '%20' + url;
          break;
        case 'pinterest':
          shareUrl = 'https://pinterest.com/pin/create/button/?url=' + url + '&media=' + image + '&description=' + title;
          break;
      }

      if (shareUrl) {
        var left = (screen.width - w) / 2;
        var top = (screen.height - h) / 2;
        window.open(shareUrl, 'share', 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',toolbar=no,menubar=no');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTagsWrap(wrap) {
      if (!wrap || wrap.dataset.tagsInit === 'true') return;
      var scroller = wrap.querySelector('[data-tags-scroll]');
      var prev = wrap.querySelector('[data-tags-prev]');
      var next = wrap.querySelector('[data-tags-next]');
      if (!scroller || !prev || !next) return;
      wrap.dataset.tagsInit = 'true';

      function update() {
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var overflowing = maxScroll > 1;
        var x = scroller.scrollLeft;
        prev.hidden = !overflowing || x <= 1;
        next.hidden = !overflowing || x >= maxScroll - 1;
      }

      function step(dir) {
        var amount = Math.max(scroller.clientWidth * 0.8, 120);
        scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-tags-wrap]').forEach(initTagsWrap);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var wrap = event.target.querySelector('[data-tags-wrap]');
      if (wrap) initTagsWrap(wrap);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-faq"] && !Shopify.designMode) return;
  try {
    
  if (window.__fwFaqDelegated) return;
  window.__fwFaqDelegated = true;

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-faq-list] details > summary');
    if (!summary) return;

    const details = summary.closest('details');
    const list = summary.closest('[data-faq-list]');
    if (!details || !list) return;

    if (!details.open) {
      list.querySelectorAll('details[open]').forEach((openDetails) => {
        if (openDetails !== details) openDetails.removeAttribute('open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-overview"] && !Shopify.designMode) return;
  try {
    
  if (!window.__fwFaqDelegated) {
    window.__fwFaqDelegated = true;

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('[data-faq-list] details > summary');
      if (!summary) return;

      const details = summary.closest('details');
      const list = summary.closest('[data-faq-list]');
      if (!details || !list) return;

      if (!details.open) {
        list.querySelectorAll('details[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.removeAttribute('open');
        });
      }
    });
  }

  (function initFaqOverview() {
    const root = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('[data-faq-overview]')
      : null;
    const container = root || document.querySelector('[data-faq-overview]');
    if (!container || container.dataset.faqOverviewInit === 'true') return;
    container.dataset.faqOverviewInit = 'true';

    const tabs = Array.from(container.querySelectorAll('[data-faq-tab]'));
    const panels = Array.from(container.querySelectorAll('[data-faq-panel]'));

    const activate = (handle, { scroll = false } = {}) => {
      const target = tabs.find((t) => t.dataset.faqTab === handle) || tabs[0];
      if (!target) return;
      const targetHandle = target.dataset.faqTab;

      tabs.forEach((tab) => {
        const isActive = tab === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.faqPanel === targetHandle;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (scroll && window.matchMedia('(max-width: 749px)').matches) {
        const content = container.querySelector('.fw-faq-overview__content');
        if (content) content.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const handle = tab.dataset.faqTab;
        activate(handle, { scroll: true });
        if (history.replaceState) {
          history.replaceState(null, '', '#' + tab.getAttribute('href').slice(1));
        } else {
          window.location.hash = tab.getAttribute('href');
        }
      });
    });

    const fromHash = () => {
      const hash = window.location.hash.slice(1);
      if (!hash) return;
      const matched = panels.find((panel) => panel.id === hash || hash.endsWith('-' + panel.dataset.faqPanel));
      if (matched) activate(matched.dataset.faqPanel);
    };

    window.addEventListener('hashchange', fromHash);
    fromHash();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (window.__fwFaqDelegated) return;
  window.__fwFaqDelegated = true;

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-faq-list] details > summary');
    if (!summary) return;

    const details = summary.closest('details');
    const list = summary.closest('[data-faq-list]');
    if (!details || !list) return;

    if (!details.open) {
      list.querySelectorAll('details[open]').forEach((openDetails) => {
        if (openDetails !== details) openDetails.removeAttribute('open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
